import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorMessagePipeModule } from '@nano/common/error-message-pipe';
import { ImageModule } from '@nano/common/image';
import { L10nTranslationModule } from 'angular-l10n';
import { NzUploadModule } from 'ng-zorro-antd/upload';

import { FileCommonModule } from '../file-common/file-common.module';
import { FileUploadComponent } from './file-upload.component';

@NgModule({
  imports: [CommonModule, ErrorMessagePipeModule, ImageModule, L10nTranslationModule, NzUploadModule, FileCommonModule],
  declarations: [FileUploadComponent],
  exports: [FileUploadComponent]
})
export class FileUploadModule {}
